import React, { createContext, useContext, useState, useEffect } from 'react';
import { getProfile } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ts_token');
    if (token) {
      getProfile()
        .then(data => setVendor(data.vendor))
        .catch(() => localStorage.removeItem('ts_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const loginVendor = (token, vendorData) => {
    localStorage.setItem('ts_token', token);
    setVendor(vendorData);
  };

  const logout = () => {
    localStorage.removeItem('ts_token');
    setVendor(null);
  };

  return (
    <AuthContext.Provider value={{ vendor, loading, loginVendor, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
